/* eslint-env browser */
/* eslint-disable arrow-body-style */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { setNavbarTab } from '../../Actions/ToggleActions';
import { URL_TYPES } from '../../Constants';

const TabCareer = () => {
  const dispatch = useDispatch();

  const { careers } = useSelector(state => state.Career);
  const {
    language, text: { tabCareer: pageText },
  } = useSelector(state => state.Language);
  const municipality = useSelector(state => state.MunicipalityReducer);

  return (
    <div className="tab-contact-inner">
      <h2 className="m0">{pageText.heading} {municipality.name}</h2>
      <p>{pageText.contentP1}
        <br />
        <br />
        {pageText.contentP2}
      </p>
      { careers.length > 0 ? careers.map((career) => {
            return (
              <input
                className="btn theme w100 mt10"
                key={career.careerName}
                type="button"
                tabIndex="0"
                value={career.menuContent[language].name}
                onClick={() => {
                  dispatch(setNavbarTab(''));
                  dispatch(push(`/${language}/${municipality.name}/${URL_TYPES.CAREER}/${career.careerName}`));
                }}
              />
            );
        }) : null }
    </div>
  );
};

export default TabCareer;



// WEBPACK FOOTER //
// ./src/Components/Tabs/TabCareer.js